import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { getPlayerStats, getPlayerStatsSeason } from "../../../../shared/utils/opta/statsHandler";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

import {
  positionTranslations,
  positionExtension,
} from "../../../../shared/utils/opta/player";
import { useTranslation } from "react-i18next";
import { getPlayerPosition } from "../../../../shared/utils/players";
import Image from "../../../../shared/components/Image";
import { getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";
import { BildPlayerTriko } from "../../_partials/BildPlayerTriko/Index";


function getPositionType(position) {
  position = Number(position);  // or parseInt(position)
  let positionType;
  if (position === 1) {
    positionType = 'keeper';
  } else if (position >= 2 && position <= 5) {
    positionType = 'defender';
  } else if ((position >= 6 && position <= 9) || position === 13) {
    positionType = 'midfielder';
  } else if (position >= 10 && position <= 12) {
    positionType = 'attacker';
  } else {
    positionType = 'unknown';  // In case of invalid position number
  }
  return positionType;
}

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const { t } = useTranslation();

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;

  const matchInfo = _.get(dynamic, "matchInfo");
  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;

  const homeTopPlayer = _.get(dynamic, "homeTopPlayer");
  const awayTopPlayer = _.get(dynamic, "awayTopPlayer");
  const positionValues = _.get(dynamic, "positionValues");
  const hasGoal = _.get(dynamic, "hasGoal");
  const homePlayerPosition = homeTopPlayer?.person?.person_detail?.position_1;
  const awayPlayerPosition = awayTopPlayer?.person?.person_detail?.position_1;
  const homeTopPlayerPosition = positionValues?.find((p) => p.id === homePlayerPosition)?.name;
  const awayTopPlayerPosition = positionValues?.find((p) => p.id === awayPlayerPosition)?.name;
  const position = getPositionType(homePlayerPosition);

  let firstTitle = t("Goals", { keyPrefix: "templates" });
  let homeFirstValue = homeTopPlayer?.goals;
  let awayFirstValue = awayTopPlayer?.goals;
  let secondTitle = t("Expected Goals", { keyPrefix: "MVP" });
  let homeSecondValue = homeTopPlayer?.expected_goals?.toFixed(2);
  let awaySecondValue = awayTopPlayer?.expected_goals?.toFixed(2);
  let thirdTitle = t("ontargetScoringAtt", { keyPrefix: "stats" });
  let homeThirdValue = homeTopPlayer?.shots_on_target;
  let awayThirdValue = awayTopPlayer?.shots_on_target;
  let fourthTitle = t("total assists", { keyPrefix: "rankingLabels" });
  let homeFourthValue = homeTopPlayer?.assists;
  let awayFourthValue = awayTopPlayer?.assists;
  if (!hasGoal) {
    firstTitle = t("Expected Goals", { keyPrefix: "MVP" });
    homeFirstValue = homeTopPlayer?.expected_goals?.toFixed(2);
    awayFirstValue = awayTopPlayer?.expected_goals?.toFixed(2);
    secondTitle = t("Shots inside the Box", { keyPrefix: "MVP" });
    homeSecondValue = homeTopPlayer?.shots_inside_box;
    awaySecondValue = awayTopPlayer?.shots_inside_box;
    thirdTitle = t("Shots outside the Box", { keyPrefix: "MVP" });
    homeThirdValue = homeTopPlayer?.shots_outside_box;
    awayThirdValue = awayTopPlayer?.shots_outside_box;
    fourthTitle = t("total assists", { keyPrefix: "rankingLabels" });
    homeFourthValue = homeTopPlayer?.assists;
    awayFourthValue = awayTopPlayer?.assists;
  }
  if (position === 'midfielder') {
    firstTitle = t("Passes Complete", { keyPrefix: "MVP" });
    homeFirstValue = homeTopPlayer?.passes_complete;
    awayFirstValue = awayTopPlayer?.passes_complete;
    secondTitle = t("Passes into final third", { keyPrefix: "MVP" });
    homeSecondValue = homeTopPlayer?.passes_into_final_third;
    awaySecondValue = awayTopPlayer?.passes_into_final_third;
    thirdTitle = t("total assists", { keyPrefix: "rankingLabels" });
    homeThirdValue = homeTopPlayer?.assists;
    awayThirdValue = awayTopPlayer?.assists;
    fourthTitle = t("Balls touched", { keyPrefix: "MVP" });
    homeFourthValue = homeTopPlayer?.balls_touched;
    awayFourthValue = awayTopPlayer?.balls_touched;
  } else if (position === 'defender') {
    firstTitle = t("Passes Complete", { keyPrefix: "MVP" });
    homeFirstValue = homeTopPlayer?.passes_complete;
    awayFirstValue = awayTopPlayer?.passes_complete;
    secondTitle = t("Passes into final third", { keyPrefix: "MVP" });
    homeSecondValue = homeTopPlayer?.passes_into_final_third;
    awaySecondValue = awayTopPlayer?.passes_into_final_third;
    thirdTitle = t("total assists", { keyPrefix: "rankingLabels" });
    homeThirdValue = homeTopPlayer?.assists;
    awayThirdValue = awayTopPlayer?.assists;
    fourthTitle = t("Balls touched", { keyPrefix: "MVP" });
    homeFourthValue = homeTopPlayer?.balls_touched;
    awayFourthValue = awayTopPlayer?.balls_touched;
  }
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Head 2 Head", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className="main-content-side">

            <div className={"left-block-side"}>
              <BildPlayerTriko
                className={"left-player"}
                player={homeTopPlayer}
                teamId={homeTeam?.id}
                side={"home"}
                team={homeTeam}
                position={homeTopPlayerPosition}
              />
              <div className="left-block-shadow"></div>
            </div>
            <div className={"center-block-side"}>
              <div className="center-row item-player">
                {/* "Games Played" */}
                <div className="item-row-left">
                  {homeFirstValue}
                </div>
                <div className="item-row-center">
                  {firstTitle}
                </div>
                <div className="item-row-right">
                  {awayFirstValue}
                </div>
              </div>

              <div className="center-row item-goal">
                <div className="item-row-left">
                  {/* {statsMappingHome.filter((mapping) => mapping.type === 'Goals')?.[0]?.value} */}
                  {homeSecondValue}
                </div>
                <div className="item-row-center">
                  {secondTitle}
                </div>
                <div className="item-row-right">
                  {awaySecondValue}
                </div>
              </div>

              <div className="center-row item-shots">
                <div className="item-row-left">
                  {homeThirdValue}
                </div>
                <div className="item-row-center">
                  {thirdTitle}
                </div>
                <div className="item-row-right">
                  {awayThirdValue}
                </div>
              </div>

              <div className="center-row item-assist">
                <div className="item-row-left">
                  {homeFourthValue}
                </div>
                <div className="item-row-center">
                  {fourthTitle}
                </div>
                <div className="item-row-right">
                  {awayFourthValue}
                </div>
              </div>
            </div>

            <div className={"right-block-side"}>
              <BildPlayerTriko
                className={"right-player"}
                player={awayTopPlayer}
                teamId={awayTeam?.id}
                side={"away"}
                team={awayTeam}
                position={awayTopPlayerPosition}
              />
              <div className="right-block-shadow"></div>
            </div>

          </div>


        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
